import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import { fetchAccountingPermissions } from "../libs/customerCreatePermission";

/**
 * @param {string|string[]} feature - một feature hoặc danh sách (OR: đủ canView một mục là vào được)
 * @param {Function} [fetchPermissions] - hàm lấy quyền theo feature (mặc định: quyền kế toán)
 */
const AccountingFeatureGate = ({ feature, fetchPermissions = fetchAccountingPermissions, children }) => {
  const [perm, setPerm] = useState({ loaded: false, canView: false });
  const features = Array.isArray(feature) ? feature : [feature];

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const results = await Promise.all(
        features.map((f) => fetchPermissions(axiosInstance, f))
      );
      if (cancelled) return;
      const canView = results.some((p) => Boolean(p?.canView));
      setPerm({ loaded: true, canView });
      if (!canView) {
        toast.warn("Bạn không có quyền truy cập màn hình này");
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features.join("|")]);

  if (!perm.loaded) return null;
  if (!perm.canView) return <Navigate to="/admin-welcome" replace />;
  return children;
};

export const ACCOUNTING_ROUTE_FEATURES = {
  "/ke-toan/bao-cao": [
    "KẾ TOÁN / Báo cáo",
    "KẾ TOÁN / Dòng tiền",
    "KẾ TOÁN / Báo cáo / Doanh thu",
    "KẾ TOÁN / Báo cáo / Chi phí",
    "KẾ TOÁN / Báo cáo / Lợi nhuận",
    "KẾ TOÁN / Báo cáo / Tài sản",
    "KẾ TOÁN / Báo cáo / Dòng tiền",
  ],
  "/ke-toan/cong-no": [
    "KẾ TOÁN / Công nợ",
    "KẾ TOÁN / Công nợ / Phải thu",
    "KẾ TOÁN / Công nợ / Phải trả",
  ],
  "/ke-toan/phieu-thu-chi": [
    "KẾ TOÁN / Phiếu thu/chi",
    "KẾ TOÁN / Phiếu thu/chi / Phiếu thu",
    "KẾ TOÁN / Phiếu thu/chi / Phiếu chi",
  ],
  "/ke-toan/cau-hinh": [
    "KẾ TOÁN / Cấu hình",
    "KẾ TOÁN / Cấu hình / Tài khoản ngân hàng",
    "KẾ TOÁN / Cấu hình / Danh mục thu",
    "KẾ TOÁN / Cấu hình / Danh mục chi",
    "KẾ TOÁN / Cấu hình / Đối tượng chi",
    "KẾ TOÁN / Cấu hình / Đối tượng thu",
    "KẾ TOÁN / Cấu hình / Cấu hình lương",
  ],
  "/ke-toan/dong-tien": "KẾ TOÁN / Báo cáo / Dòng tiền",
  "/ke-toan/nhan-su": [
    "KẾ TOÁN / Lương & Tạm ứng",
    "KẾ TOÁN / Sổ chi",
    "KẾ TOÁN / Sổ chi / Bảng lương",
    "KẾ TOÁN / Sổ chi / Tạm ứng",
    "KẾ TOÁN / Sổ chi / Chi phí trả trước",
  ],
};

export default AccountingFeatureGate;
